module.exports = __webpack_public_path__ + "36a260338e8077d28f902916f6e5fe66.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Regular-webfont.woff
// module id = 223
// module chunks = 0